import React from 'react'
import LoaderLogo from '../../Assets/Images/buypolicynow.png'

const Loader = () => {
    return (
        <>
            <div className='loader-component'>
                <img src={LoaderLogo} alt='loader'  style={{height:'150px'}}/>
                <section class="dots-container mt-2">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                </section>

            </div>
        </>
    )
}

export default Loader